import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import styles from './SbRespMoreWaysToBrowse.scss';

const SbRespMoreWaysToBrowseComponent = ({ searchBrowse }) => {
    const { internalBuyLinks } = searchBrowse;
    const title = (
        <FormattedMessage id="SbRespMoreWaysToBrowse.title" defaultMessage="More Ways to Browse" />
    );

    if (internalBuyLinks && internalBuyLinks.length) {
        return (
            <div data-tn="sb-resp-more-ways-to-browse" className={styles.wrapper}>
                <BarHeader title={title} />
                <div className={`${styles.links} rowFlex`}>
                    {internalBuyLinks.map(({ anchorText, url }) => (
                        <div key={url} className={`${styles.link} colXs12 colMd4`}>
                            <a href={url}>{anchorText}</a>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    return null;
};

SbRespMoreWaysToBrowseComponent.propTypes = {
    searchBrowse: PropTypes.shape({
        internalBuyLinks: PropTypes.arrayOf(
            PropTypes.shape({
                anchorText: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
            })
        ),
    }).isRequired,
};

export const SbRespMoreWaysToBrowse = createFragmentContainer(SbRespMoreWaysToBrowseComponent, {
    searchBrowse: graphql`
        fragment SbRespMoreWaysToBrowse_searchBrowse on SearchBrowseQueryConnection {
            internalBuyLinks {
                anchorText
                url
            }
        }
    `,
});
